import { Observable } from "rxjs";
import * as http from "../../../services/http.service";
import { WidenSignature } from "../types/dam-signature-response.interface";
import { Nullable } from "../../../types/common";
import moment from "moment";

export function fetchSignature(): Observable<WidenSignature> {
  return http.get<WidenSignature>("/widen-signature/");
}

export function signatureValid(
  signature: Nullable<WidenSignature>,
  signatureFetchedAt: Nullable<Date>
): boolean {
  if (!signature || !signatureFetchedAt) {
    return false;
  }

  return moment(new Date()).isBefore(moment(signatureFetchedAt).add(30, "minutes"));
}
